@for (pos of positions; track pos) {
  <div class="toast-container flex flex-col gap-8 fixed overflow-hidden" [class]="pos" [style.z-index]="grouped()[pos]?.[0]?.zIndex">
    @for (toast of grouped()[pos]; track toast.id) {
      <div class="toast {{toast.type}} flex justify-between items-center w-100 border-box overflow-hidden"
        [class.show]="toast.visible()"
        [class.hide]="!toast.visible()"
      >
        @if (toast?.contentIcon) {
          <app-svg-icon class="pl-14" [name]="toast?.contentIcon"></app-svg-icon>
        }

        @if (toast?.contentImg) {
          <img width="32px" height="32px" class="ml-14" [src]="toast?.contentImg" [alt]="toast?.contentImg">
        }
        @if (typeof toast.content === 'string') {
          <div class="py-12 cursor-pointer" [class.pl-10]="!!toast?.contentIcon" [class.px-16]="!toast?.contentIcon" (click)="toastService.click(toast)" [innerHTML]="toast.content | safe:'html'"></div>
          @if (toast?.closeIcon) {
            <app-svg-icon class="p-10" name="close-20px" [cssColor]="true" (click)="toast?.ref?.close(false)"></app-svg-icon>
          }
        } @else {
          <ng-container *ngComponentOutlet="toast.content.component; inputs: toast.content.inputs"
          />
        }
      </div>
    }
  </div>
}
